/* SimSau: progressive enhancement. Content never relies on animation to be visible. */
(function () {
  'use strict';
  var instances = new Map();
  var preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root) {
    if (!root || instances.has(root)) return;
    var controller = new AbortController();
    var signal = controller.signal;
    var animations = new Set();
    var observer, ambientObserver;
    function play(element, keyframes, options) {
      if (preference.matches || !element.animate || document.hidden) return;
      var animation = element.animate(keyframes, options);
      animations.add(animation);
      animation.finished.then(function(){ animations.delete(animation); }, function(){ animations.delete(animation); });
    }
    root.classList.add('ss-motion-ready');
    var groups = [
      ['.ss-hero-copy > *', 75],
      ['.ss-begin-picture, .ss-begin-copy', 70],
      ['.ss-step-list > li', 90],
      ['.ss-objects .ss-section-heading, .ss-products > article', 75],
      ['.ss-ritual h2, .ss-ritual p', 85],
      ['.ss-faq > h2, .ss-faq-grid > details', 60],
      ['.ss-journal > h2, .ss-journal-grid > article', 75],
      ['.ss-footer-main > *', 65]
    ];
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          play(entry.target, [
            { opacity: 0, transform: 'translateY(' + (window.innerWidth < 750 ? '8' : '14') + 'px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], { duration: 760, delay: Number(entry.target.dataset.ssDelay || 0), easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' });
        });
      }, { threshold: 0.12 });
      groups.forEach(function(group) {
        root.querySelectorAll(group[0]).forEach(function(element,index) {
          element.dataset.ssDelay = Math.min(index * group[1], 180);
          observer.observe(element);
        });
      });
      ambientObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) { entry.target.classList.toggle('ss-is-in-view',entry.isIntersecting); });
      }, { threshold: 0.05 });
      root.querySelectorAll('.ss-hero-caption, .ss-hero-trail, .ss-begin-trail, .ss-steps-trail').forEach(function(element) {
        element.setAttribute('data-ss-ambient','');
        ambientObserver.observe(element);
      });
    }
    root.querySelectorAll('.ss-faq details').forEach(function(details) {
      details.addEventListener('toggle', function() {
        if (details.open) {
          var answer = details.querySelector('p');
          if (answer) play(answer, [{opacity:0, transform:'translateY(-4px)'},{opacity:1,transform:'translateY(0)'}],{duration:320,easing:'ease-out'});
        }
      }, {signal:signal});
    });
    function syncPreference() {
      if (preference.matches) {
        animations.forEach(function(animation){animation.cancel();});
        animations.clear();
      }
      root.classList.toggle('ss-motion-paused',document.hidden || preference.matches);
    }
    document.addEventListener('visibilitychange',syncPreference,{signal:signal});
    preference.addEventListener('change',syncPreference,{signal:signal});
    syncPreference();
    instances.set(root,function() {
      controller.abort();
      if(observer) observer.disconnect();
      if(ambientObserver) ambientObserver.disconnect();
      animations.forEach(function(animation){animation.cancel();});
      instances.delete(root);
    });
  }
  function scan(scope) {
    if (scope.matches && scope.matches('.ss')) init(scope);
    scope.querySelectorAll('.ss').forEach(init);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){scan(document);},{once:true});
  else scan(document);
  document.addEventListener('shopify:section:load',function(event){scan(event.target);});
  document.addEventListener('shopify:section:unload',function(event){
    instances.forEach(function(dispose,root){if(event.target.contains(root)) dispose();});
  });
})();